/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Priceincrease1Inputs */

const he_statistics_priceincrease1 = /** @type {(inputs: Statistics_Priceincrease1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עליות מחיר`)
};

const en_statistics_priceincrease1 = /** @type {(inputs: Statistics_Priceincrease1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price increases`)
};

/**
* | output |
* | --- |
* | "Price increases" |
*
* @param {Statistics_Priceincrease1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const statistics_priceincrease1 = /** @type {((inputs?: Statistics_Priceincrease1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Priceincrease1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_priceincrease1(inputs)
	return en_statistics_priceincrease1(inputs)
});
export { statistics_priceincrease1 as "statistics_priceIncrease" }